import React from "react";

import { Input } from "antd";

import { ReactComponent as LockFill } from "../../../../../../assets/images/lock-fill.svg";

import "./FixedValueInput.css";

/**
 * Read-only onboarding field with the lock-fill prefix.
 */
export default function FixedValueInput(props) {
  return (
    <Input
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      disabled
      prefix={<LockFill className="FixedValueInput__Lock" aria-hidden />}
      className={`FixedValueInput ${props.className ?? ""}`.trim()}
    />
  );
}
